<app-stats-overlay>
  <grid-layout withExport (onExport)="exportAsCsv()">
    <ag-grid-angular
      style="width: 100%; height: 100%"
      class="grid-height"
      [rowData]="brandAliases"
      [gridOptions]="gridOptions"
    />
  </grid-layout>
</app-stats-overlay>
